<template>
   <a-card :bordered="false">
    <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="personid"
          class="j-table-force-nowrap"
          :scroll="{x:500}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
        
        </a-table>
   </a-card>
  </template>
  
  
  <script>
  import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
  import {validateDuplicateValue} from '@/utils/util'
  import { httpAction, getAction } from '@/api/manageChooseSeat'
  import moment from 'moment'
  
  export default {
    name: 'ActivityForm',
    model:{},
    components: {},
    
    mixins:[JeecgListMixin],
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {},
        uploadSource:"chooseseat",
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
      confirmLoading: false,

        url: {
          list:"/PersonInfo/getPersonSelected",
          add: "/ActivityInfo/addData",
          edit: "/ActivityInfo/editData"
        },
        selectVenueList:[]
      }
    },

    inject: ['operation'],
    computed: {

      columns() {
      if (this.language) {
        return [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          //人员id
          {
            title: this.language['cs.person.personid'],
            align: "left",
            ellipsis: true,
            width: 100,
            dataIndex: 'personid'
          },
          //姓名
          {
            title: this.language['cs.person.pname'],
            ellipsis: true,
            width: 100,
            align: "left",
            dataIndex: 'pname'
          },
          //单位
          {
            title: this.language['cs.person.deptname'],
            align: "left",
            ellipsis: true,
            dataIndex: 'deptname',
            width: 100
            // customRender: (t, r, index) => {
            //   return this.filterListText(this.selectDataAreaCodeList, t, 'value')
            // }
          },
          //职称
          {
            title: this.language['cs.person.jobname'],
            width: 100,
            align: "left",
            dataIndex: 'jobname',
            ellipsis: true
          },
        ]
      }
    },
      language() {
        return this.$store.getters.language
      },
      formDisabled() {
        return this.disabled
      },
      validatorRules() {
        if (this.language) {
          return {
            activityname: [
              {required: true, message: this.language['cs.input']+this.language['cs.activity.activityname']+'!'}
            ],
            sysvenueidlist: [
              {required: true, message: this.language['cs.select']+this.language['cs.venue.venuename']+'!'}
            ],
            startdate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ], 
            enddate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ],
            seatstartdate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ],
            seatenddate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ]

          }
        }
      }
  
    },
    created() {
    //   //备份model原始值
    //   this.modelDefault = JSON.parse(JSON.stringify(this.model));
    //  this.loadSelectData();
    },
    mounted(){
    
      },
      watch: {
    },
    methods: {

      initDictConfig()
      {
        this.queryParam = Object.assign({}, this.operation.record);
      },
      loadSelectData() { 
          this.selectVenueList=null;  
          let selectvenue= { keytype: "venue", parentid:"",curvalue:this.model.sysvenueids};  
           getAction('/PersonInfo/getPersonSelected', selectvenue).then((res) => {
          if (res.success) {
            this.selectVenueList= res.result.records;
          }
      });  
      },
      disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'days').endOf('day')
    },
   

      add() {
        this.edit(this.modelDefault);
      },
      edit(record) {
        // this.model=Object.assign({},record);
        this.visible = true;
      },

     
      submitForm() {
        const that = this;
        if(that.enddate=="")
        {
          that.$message.warning(that.language['cs.select']+that.language['cs.activity.startenddate']);
          return;
        }
        if(that.seatenddate=="")
        {
          that.$message.warning(that.language['cs.select']+that.language['cs.activity.seatstartenddate']);
          return;
        }
        if(that.enddate<that.startdate|| that.seatenddate<that.seatstartdate)
        {
          that.$message.warning("日期起止時間不合法 ");
          return;

        }
        // 触发表单验证
        this.$refs.form.validate(valid => {
  
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.sysactivityid) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
  
        })
      },
   
    }
  }
  
  
  </script>